var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.isCapturable()
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("global.messages.warning.ordenRequerido")
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _vm.isCapturable()
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "grp-nombre-proyecto-id",
                            "label-for": "nombre-proyecto-id",
                          },
                        },
                        [
                          _c("input-text", {
                            attrs: {
                              id: "nombre-proyecto-id",
                              label: _vm.$t(
                                "busqueda-institucion.nombre-proyecto"
                              ),
                              max: 100,
                              readonly:
                                (_vm.institucionCards.length > 0 &&
                                  !_vm.isEdit) ||
                                _vm.readOnly,
                              state: !_vm.$v.form.nombreProyecto.$invalid,
                              valid: _vm.$v.form.nombreProyecto.$dirty
                                ? !_vm.$v.form.nombreProyecto.$error
                                : null,
                              validationsCommons: {
                                requiredValue:
                                  !_vm.$v.form.nombreProyecto.required,
                                requiredMessage: _vm.$t(
                                  "entity.validation.required"
                                ),
                                maxValue: !_vm.$v.form.nombreProyecto.maxLength,
                                maxMessage: _vm.$t(
                                  "busqueda-institucion.buscador-institucion.validations.maxMessage",
                                  { max: "100" }
                                ),
                              },
                            },
                            model: {
                              value: _vm.$v.form.nombreProyecto.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.form.nombreProyecto,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.nombreProyecto.$model",
                            },
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "float-right" }, [
                            _vm._v(
                              _vm._s(_vm.form.nombreProyecto.length) + "/100"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "busqueda-institucion.objetivo-estancia"
                            ),
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "objetivo-estancia-id",
                              maxlength: 500,
                              disabled:
                                (_vm.institucionCards.length > 0 &&
                                  !_vm.isEdit) ||
                                _vm.readOnly,
                              state: !_vm.$v.form.objetivoEstancia.$invalid,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.chageText(
                                  _vm.form.objetivoEstancia,
                                  "objetivoEstancia"
                                )
                              },
                            },
                            model: {
                              value: _vm.$v.form.objetivoEstancia.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.form.objetivoEstancia,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.objetivoEstancia.$model",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.form.objetivoEstancia.required &&
                          !_vm.readOnly
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("entity.validation.required"))
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", { staticClass: "float-right" }, [
                            _vm._v(
                              _vm._s(_vm.form.objetivoEstancia.length) + "/500"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "busqueda-institucion.resultado-estancia"
                            ),
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "res-objetivo-estancia-id",
                              maxlength: 500,
                              disabled:
                                (_vm.institucionCards.length > 0 &&
                                  !_vm.isEdit) ||
                                _vm.readOnly,
                              required: true,
                              state: !_vm.$v.form.resultadoEstancia.$invalid,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.chageText(
                                  _vm.form.resultadoEstancia,
                                  "resultadoEstancia"
                                )
                              },
                            },
                            model: {
                              value: _vm.$v.form.resultadoEstancia.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.form.resultadoEstancia,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.resultadoEstancia.$model",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.form.resultadoEstancia.required &&
                          !_vm.readOnly
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("entity.validation.required"))
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", { staticClass: "float-right" }, [
                            _vm._v(
                              _vm._s(_vm.form.resultadoEstancia.length) + "/500"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm.institucionCards.length > 0 && !_vm.isEdit
                        ? _c("cards-list", {
                            attrs: {
                              id: "busqueda-institucion-card-id",
                              items: _vm.institucionCards,
                              title:
                                _vm.tipo == 2
                                  ? _vm.$t("busqueda-institucion.titleCard2")
                                  : _vm.$t("busqueda-institucion.titleCard"),
                              mostrarListado: false,
                            },
                            on: {
                              remove: _vm.removeInstitucion,
                              edit: _vm.prepareBusquedaInstitucion,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.institucionCards.length > 0 && !_vm.isEdit
                    ? _c("b-col", { attrs: { cols: "12" } }, [
                        _vm.isSolicitante
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn-group float-right",
                                    attrs: { variant: "primary", size: "md" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.prepareBusquedaInstitucion(0)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "busqueda-institucion.action.edit"
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "icon-editar mr-2",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.institucionCards.length == 0 || _vm.isEdit
                    ? _c("b-col", { attrs: { md: "12" } }, [
                        _c(
                          "header",
                          { staticClass: "mt-5 bx-header-title" },
                          [
                            _c(
                              "b-alert",
                              {
                                staticClass: "text-justify",
                                attrs: { show: "", variant: "primary" },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("busqueda-institucion.texto-ayuda")
                                    ),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-alert",
                                  { attrs: { show: "", variant: "info" } },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("busqueda-institucion.nota")
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.existeTipoApoyo
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-alert",
                                      {
                                        attrs: { show: "", variant: "warning" },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "busqueda-institucion.tipoApoyoRequerido"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isEdit && _vm.existeTipoApoyo
                              ? _c("h3", {
                                  staticClass: "inline",
                                  attrs: {
                                    id: "busqueda-institucion-title-id",
                                  },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.tipo == 2
                                        ? _vm.$t(
                                            "busqueda-institucion.title2",
                                            {
                                              requiredString: _vm.required
                                                ? "*"
                                                : "",
                                            }
                                          )
                                        : _vm.$t("busqueda-institucion.title", {
                                            requiredString: _vm.required
                                              ? "*"
                                              : "",
                                          })
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isEdit && _vm.existeTipoApoyo
                              ? _c(
                                  "div",
                                  { staticClass: "mt-3 float-right" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: { click: _vm.edit },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "busqueda-institucion.action.add"
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "icon-mas" }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? [
                        !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c("input-text", {
                                  staticClass: "mb-4",
                                  attrs: {
                                    id: "busquedaInstitucion.buscadorInstitucion-id",
                                    label: _vm.$t(
                                      "busqueda-institucion.buscador-institucion.label"
                                    ),
                                    readonly: _vm.readOnly,
                                    required: false,
                                    placeholder: _vm.placeholderBuscador,
                                    valid: _vm.$v.busquedaInstitucion
                                      .buscadorInstitucion.$dirty
                                      ? !_vm.$v.busquedaInstitucion
                                          .buscadorInstitucion.$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion
                                          .buscadorInstitucion.required,
                                      requiredMessage: _vm.$t(
                                        "entity.validation.required"
                                      ),
                                      minValue:
                                        !_vm.$v.busquedaInstitucion
                                          .buscadorInstitucion.minLength,
                                      minMessage: _vm.$t(
                                        "busqueda-institucion.buscador-institucion.validations.minMessage",
                                        { min: "3" }
                                      ),
                                      maxValue:
                                        !_vm.$v.busquedaInstitucion
                                          .buscadorInstitucion.maxLength,
                                      maxMessage: _vm.$t(
                                        "busqueda-institucion.buscador-institucion.validations.maxMessage",
                                        { max: "100" }
                                      ),
                                    },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onTipoChanged(
                                        _vm.$v.busquedaInstitucion
                                          .tipoInstitucion.$model.id
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion
                                        .buscadorInstitucion.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion
                                          .buscadorInstitucion,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.buscadorInstitucion.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c("input-select-radio", {
                                  staticClass: "mb-4",
                                  attrs: {
                                    id: "busquedaInstitucion.tipoInstitucion-id",
                                    label: _vm.$t(
                                      "busqueda-institucion.tipo-institucion.label"
                                    ),
                                    options: _vm.catTipoInstitucion,
                                    readonly: _vm.readOnly,
                                    required: true,
                                    valid: _vm.$v.busquedaInstitucion
                                      .tipoInstitucion.$dirty
                                      ? !_vm.$v.busquedaInstitucion
                                          .tipoInstitucion.$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion
                                          .tipoInstitucion.required,
                                      requiredMessage: _vm.$t(
                                        "busqueda-institucion.tipo-institucion.validations.required"
                                      ),
                                    },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onTipoChanged($event.id)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion.tipoInstitucion
                                        .$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion
                                          .tipoInstitucion,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.tipoInstitucion.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _vm.publicPrivadaIf && !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12", md: "4", lg: "4" } },
                              [
                                _c("input-select-one", {
                                  attrs: {
                                    id: "publica-privada-id",
                                    label: _vm.$t(
                                      "busqueda-institucion.publica-privada.label"
                                    ),
                                    options: _vm.catPublicaPrivada,
                                    readonly:
                                      _vm.readOnly ||
                                      _vm.$v.busquedaInstitucion
                                        .buscadorInstitucion.$invalid,
                                    required: true,
                                    valid: _vm.$v.busquedaInstitucion
                                      .publicaPrivada.$dirty
                                      ? !_vm.$v.busquedaInstitucion
                                          .publicaPrivada.$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion
                                          .publicaPrivada.required,
                                      requiredMessage: _vm.$t(
                                        "busqueda-institucion.publica-privada.validations.required"
                                      ),
                                    },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onPublicaPrivadaChanged($event)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion.publicaPrivada
                                        .$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion
                                          .publicaPrivada,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.publicaPrivada.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _vm.paisIf && !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12", md: "4", lg: "4" } },
                              [
                                _c("input-select-one", {
                                  attrs: {
                                    id: "pais-id",
                                    label: _vm.$t(
                                      "busqueda-institucion.pais.label"
                                    ),
                                    options: _vm.catPais,
                                    readonly: _vm.readOnly,
                                    required: true,
                                    valid: _vm.$v.busquedaInstitucion.pais
                                      .$dirty
                                      ? !_vm.$v.busquedaInstitucion.pais.$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion.pais
                                          .required,
                                      requiredMessage: _vm.$t(
                                        "busqueda-institucion.pais.validations.required"
                                      ),
                                    },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onPaisChanged($event)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion.pais.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion.pais,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.pais.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _vm.entidadIf && !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12", md: "4", lg: "4" } },
                              [
                                _c("input-select-one", {
                                  attrs: {
                                    id: "entidad-id",
                                    label: _vm.$t(
                                      "busqueda-institucion.entidad.label"
                                    ),
                                    options: _vm.catEntidad,
                                    readonly: _vm.readOnly,
                                    required: true,
                                    valid: _vm.$v.busquedaInstitucion.entidad
                                      .$dirty
                                      ? !_vm.$v.busquedaInstitucion.entidad
                                          .$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion.entidad
                                          .required,
                                      requiredMessage: _vm.$t(
                                        "busqueda-institucion.entidad.validations.required"
                                      ),
                                    },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onEntidadChanged($event)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion.entidad.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion.entidad,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.entidad.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.municipioIf && !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12", md: "4", lg: "4" } },
                              [
                                _c("input-select-one", {
                                  attrs: {
                                    id: "municipio-id",
                                    label: _vm.$t(
                                      "busqueda-institucion.municipio.label"
                                    ),
                                    options: _vm.catMunicipio,
                                    readonly:
                                      _vm.$v.busquedaInstitucion.entidad
                                        .$model == null || _vm.readOnly,
                                    required: true,
                                    valid: _vm.$v.busquedaInstitucion.municipio
                                      .$dirty
                                      ? !_vm.$v.busquedaInstitucion.municipio
                                          .$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion.municipio
                                          .required,
                                      requiredMessage: _vm.$t(
                                        "busqueda-institucion.municipio.validations.required"
                                      ),
                                    },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onMunicipioChanged($event)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion.municipio
                                        .$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion.municipio,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.municipio.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _vm.institucionIf && !_vm.setteoManual
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c("input-select-one", {
                                  attrs: {
                                    id: "institucion-id",
                                    label:
                                      _vm.tipo == 2
                                        ? _vm.$t(
                                            "busqueda-institucion.institucion.label2"
                                          )
                                        : _vm.$t(
                                            "busqueda-institucion.institucion.label"
                                          ),
                                    options: _vm.catInstitucion,
                                    readonly: _vm.readOnly,
                                    required: true,
                                    valid: _vm.$v.busquedaInstitucion
                                      .institucion.$dirty
                                      ? !_vm.$v.busquedaInstitucion.institucion
                                          .$error
                                      : null,
                                    validationsCommons: {
                                      requiredValue:
                                        !_vm.$v.busquedaInstitucion.institucion
                                          .required,
                                      requiredMessage: _vm.$t(
                                        "busqueda-institucion.institucion.validations.required"
                                      ),
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.$v.busquedaInstitucion.institucion
                                        .$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.busquedaInstitucion.institucion,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.busquedaInstitucion.institucion.$model",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _vm.institucionIf
                          ? _c(
                              "b-col",
                              { attrs: { sm: "12", md: "6", lg: "6" } },
                              [
                                _c("b-link", { on: { click: _vm.openModal } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "busqueda-institucion.button-modal.mjs"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "float-right mt-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "outline-primary",
                                    size: "md",
                                  },
                                  on: { click: _vm.cancel },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "busqueda-institucion.action.cancel"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "ban" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    size: "md",
                                    disabled:
                                      _vm.validaDisabled() ||
                                      !_vm.isSolicitante,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addInstitucion(
                                        _vm.$v.busquedaInstitucion.$model
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.editingIndex === null
                                    ? _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "busqueda-institucion.action.save"
                                            )
                                          ),
                                        },
                                      })
                                    : _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "busqueda-institucion.action.edit"
                                            )
                                          ),
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "save" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.validInstComponent
                    ? [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "busqueda-institucion.generalRequired"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-overlay", {
                    attrs: {
                      show: _vm.showInst,
                      "no-wrap": "",
                      "spinner-type": "grow",
                      "spinner-variant": "primary",
                    },
                  }),
                  _vm._v(" "),
                  [
                    _c(
                      "b-modal",
                      {
                        ref: "modalInstitucionAyuda",
                        attrs: {
                          title: _vm.$t("busqueda-institucion.modal.title"),
                          size: "lg",
                          "z-index": "2",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "modal-footer",
                              fn: function ({ cancel }) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        id: "documento-probatorio-save-id",
                                        variant: "outline-primary",
                                      },
                                      on: { click: cancel },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "busqueda-institucion.modal.accept"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2137818183
                        ),
                      },
                      [
                        _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("busqueda-institucion.modal.p1")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p2")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "indentation20" }, [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("busqueda-institucion.modal.p3")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p4")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p5")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p6")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p7")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p8")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p9") +
                                " <a>" +
                                _vm.$t("busqueda-institucion.modal.p10") +
                                "</a>" +
                                _vm.$t("busqueda-institucion.modal.p11")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p"),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("busqueda-institucion.modal.p13")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation20",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p14")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "indentation20" }, [
                          _c("u", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("busqueda-institucion.modal.p15")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation20",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p16")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation20",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p17")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation20",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p18")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p19")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p20")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p21")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p22")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation40",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p23")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation20",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p24")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "indentation20",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("busqueda-institucion.modal.p25")
                            ),
                          },
                        }),
                      ]
                    ),
                  ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }